export default {
    // Bind props
    props: ['title', 'text']
};
